<div class="container-fluid" *ngIf="event">
  <div class="form-horizontal" wl-ng-models-valid (onValidChange)="handleFormValidChanged($event)">
    <h3>
      {{ 'events.settings.registration-settings.title' | translate | titlecase }}
      <span>
        <a href="https://support.weblinkinternational.com/hc/en-us/articles/235638608-Event-Settings-Registration-Settings" target="_blank">
          <img
            src="/assets/img/help.png"
            title="{{ 'events.settings.registration-settings.registration-settings-title-help' | translate }}"
            class="wc-help-icon"
          />
        </a>
      </span>
    </h3>

    <div class="form-group">
      <label class="col-sm-3 col-md-2 control-label">{{
        'events.settings.registration-settings.event-status' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-md-10">
        <div class="form-control-static">
          <div>
            <label
              ><input type="checkbox" [(ngModel)]="event.DisableRegistration" />
              {{ 'events.settings.registration-settings.disable-registration' | translate | titlecase }}</label
            >
          </div>
          <div>
            <label
              ><input type="checkbox" [(ngModel)]="event.Closed" />
              {{ 'events.settings.registration-settings.hide-event-on-calendar' | translate | titlecase }}</label
            >
          </div>
          <div>
            <label
              ><input type="checkbox" [(ngModel)]="event.AllowAttendeePortalChanges" />
              {{ 'events.settings.registration-settings.allow-attendee-portal-edit' | translate | titlecase }}</label
            >
          </div>
          <div class="mct-flex mct-row mct-items-center">
            <label class="mr-5"
              ><input type="checkbox" [(ngModel)]="event.LimitOverdueMembers" />
              {{ 'events.settings.registration-settings.prevent-members-overdue-invoice' | translate | titlecase }}</label
            >
            <input
              type="number"
              class="form-control w-7"
              id="event-registration-setting-max-attendees"
              [disabled]="!event.LimitOverdueMembers"
              [(ngModel)]="event.OverdueInvoiceOffset"
            />
            <span class="ml-5">{{ 'events.settings.registration-settings.days-past-due' | translate }}</span>
          </div>
          <div>
            <label
              ><input type="checkbox" [(ngModel)]="event.AllowPortalCancellation" />
              {{ 'events.settings.registration-settings.allow-portal-cancellation' | translate | titlecase }}</label
            >
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="event.AllowPortalCancellation" class="form-group">
      <div>
        <div>
          <label class="col-sm-3 col-md-2 control-label"></label>
          <div class="col-sm-9 col-md-10 mb-10">
            <p-radioButton
              class="mr-10"
              [(ngModel)]="event.CancellationModificationType"
              name="modificationType"
              [value]="modificationTypeEnum.CreditCardRefund"
              inputId="creditCardRefund"
            >
            </p-radioButton>
            <label for="creditCardRefund">
              {{ 'events.registration.wizard.payment-info.modification-options-refund-credit-card-payments-label' | translate | titlecase }}
            </label>
            <p-radioButton
              [(ngModel)]="event.CancellationModificationType"
              name="modificationType"
              [value]="modificationTypeEnum.UnappliedPayment"
              inputId="unappliedPayment"
            >
            </p-radioButton>
            <label for="unappliedPayment">
              {{ 'events.registration.wizard.payment-info.modification-options-create-unapplied-payments-label' | translate | titlecase }}
            </label>
          </div>
        </div>
        <div>
          <label class="col-sm-3 col-md-2 control-label">
            {{ 'events.registration.wizard.payment-info.modification-options-payment-adjustment-type-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9 col-md-10 mb-5">
            <wl-adjustment-type-selector [(ngModel)]="event.CancellationPaymentAdjustmentTypeId"></wl-adjustment-type-selector>
          </div>
        </div>
        <div>
          <label class="col-sm-3 col-md-2 control-label">
            {{ 'events.registration.wizard.payment-info.modification-options-invoice-adjustment-type-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9 col-md-10 mb-5">
            <wl-adjustment-type-selector [(ngModel)]="event.CancellationInvoiceAdjustmentTypeId"></wl-adjustment-type-selector>
          </div>
        </div>
        <div *ngIf="event.CancellationModificationType == modificationTypeEnum.UnappliedPayment">
          <label class="col-sm-3 col-md-2 control-label">
            {{ 'events.registration.wizard.payment-info.modification-options-unapplied-payment-paymen-type-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9 col-md-10">
            <wl-payment-type-selector [(ngModel)]="event.CancellationUnappliedPaymentPaymentTypeId"></wl-payment-type-selector>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-sm-3 col-md-2 control-label">Public Registration End Date</label>
      <div class="col-sm-9 col-md-10">
        <div class="input-group">
          <span class="input-group-addon">
            <input type="checkbox" [(ngModel)]="event.UsePublicRegistrationEndDate" />
          </span>
          <wl-date-selector
            [disabled]="!event.UsePublicRegistrationEndDate"
            class="input-group"
            [(ngModel)]="event.PublicRegistrationEndDateUtc"
          ></wl-date-selector>
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-3 col-md-2 control-label">{{ 'events.settings.registration-settings.entity-label' | translate | titlecase }}</div>
      <div class="col-sm-9 col-md-10">
        <select class="form-control" [(ngModel)]="event.EntityId">
          <option value="0">{{ 'common.none' | translate | titlecase }}</option>
          <option *ngFor="let entity of entities" [value]="entity.EntityID">
            {{ entity.Descr }}
          </option>
        </select>
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-3 col-md-2 control-label">
        {{ 'events.settings.registration-settings.payment-methods' | translate | titlecase }}
      </div>
      <div class="col-sm-9 col-md-10">
        <div class="mct-flex mct-row">
          <span><i class="large-icon pi pi-fw pi-exclamation-circle" style="color: red; font-size: 1.5rem"></i></span>
          <label>{{ 'revenue.credit-card-transactions.cc-fee-payment-explanation' | translate }}</label>
        </div>
        <div>
          <wl-event-v4-settings-payment-methods
            (onPaymentMethodsSaved)="paymentMethodsSaved($event)"
          ></wl-event-v4-settings-payment-methods>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-sm-3 col-md-2 control-label">{{
        'events.settings.registration-settings.event-assigned-to' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-md-10">
        <wl-user-selector
          noneText="{{ 'events.settings.registration-settings.select-a-user-placeholder' | translate | titlecase }}"
          [(ngModel)]="event.AssignedTo"
          (selectedUserChanged)="selectedAssignedToUserChangedHandler($event, notifyEmail)"
        ></wl-user-selector>
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-3 col-md-2 control-label hidden-xs">
        {{ 'events.settings.registration-settings.attendees' | translate | titlecase }}
      </div>
      <div class="col-sm-9 col-md-10">
        <div class="form-control-static">
          <div class="form-group">
            <label class="col-sm-5 col-md-4 col-lg-3" for="event-registration-setting-max-attendees">{{
              'events.settings.registration-settings.maximum-attendees' | translate | titlecase
            }}</label>
            <div class="col-sm-3">
              <input type="number" class="form-control" id="event-registration-setting-max-attendees" [(ngModel)]="event.MaxAttendees" />
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-5 col-md-4 col-lg-3" for="event-registration-setting-min-attendees">{{
              'events.settings.registration-settings.minimum-attendees' | translate | titlecase
            }}</label>
            <div class="col-sm-3">
              <input type="number" class="form-control" id="event-registration-setting-min-attendees" [(ngModel)]="event.MinAttendees" />
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-5 col-md-4 col-lg-3" for="event-registration-setting-min-attendees-date">{{
              'events.settings.registration-settings.min-attendees-action-date' | translate | titlecase
            }}</label>
            <div class="col-sm-6">
              <wl-date-selector
                id="event-registration-setting-min-attendees-date"
                [(ngModel)]="event.MinAttendeesActionDate"
              ></wl-date-selector>
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-5 col-md-4 col-lg-3" for="event-registration-setting-attendee-goal">{{
              'events.settings.registration-settings.attendee-goal' | translate | titlecase
            }}</label>
            <div class="col-sm-3">
              <input type="number" class="form-control" id="event-registration-setting-attendee-goal" [(ngModel)]="event.AttendeeGoal" />
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-5 col-md-4 col-lg-3" for="event-registration-setting-sales-goal">{{
              'events.settings.registration-settings.sales-goal' | translate | titlecase
            }}</label>
            <div class="col-sm-3">
              <input type="number" class="form-control" id="event-registration-setting-sales-goal" [(ngModel)]="event.SalesGoal" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-sm-3 col-md-2 control-label">{{
        'events.settings.registration-settings.details-page' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-md-10">
        <div class="form-control-static">
          <label
            ><input type="checkbox" [(ngModel)]="showSendQuestions" />
            {{ 'events.settings.registration-settings.show-send-questions' | translate | titlecase }}</label
          >
          <p class="wc-event-setting-cb-sub-item" [hidden]="!showSendQuestions">
            {{ 'events.settings.registration-settings.send-questions-label' | translate | titlecase }}
            <input type="email" class="form-control" [(ngModel)]="event.SendQuestionsToEmail" [required]="showSendQuestions" />
          </p>

          <div>
            <label
              ><input type="checkbox" [(ngModel)]="showSpecialDetailsPageURL" />
              {{ 'events.settings.registration-settings.show-special-details-page-url' | translate | titlecase }}</label
            >
          </div>
          <p class="wc-event-setting-cb-sub-item" [hidden]="!showSpecialDetailsPageURL">
            {{ 'events.settings.registration-settings.enter-url-label' | translate | titlecase }}
            <input type="url" class="form-control" [(ngModel)]="event.SpecialDetailsPageURL" [required]="showSpecialDetailsPageURL" />
          </p>

          <div>
            <label
              ><input type="checkbox" [(ngModel)]="showSpecialRegistrationUrl" />
              {{ 'events.settings.registration-settings.show-special-registration-url' | translate | titlecase }}</label
            >
          </div>
          <p class="wc-event-setting-cb-sub-item" [hidden]="!showSpecialRegistrationUrl">
            {{ 'events.settings.registration-settings.enter-url-label' | translate | titlecase }}
            <input type="url" class="form-control" [(ngModel)]="event.SpecialRegistrationUrl" [required]="showSpecialRegistrationUrl" />
          </p>

          <div>
            <label
              ><input type="checkbox" [(ngModel)]="showRelatedWebsite" />
              {{ 'events.settings.registration-settings.show-related-website' | translate | titlecase }}</label
            >
          </div>
          <p class="wc-event-setting-cb-sub-item" [hidden]="!showRelatedWebsite">
            {{ 'events.settings.registration-settings.enter-url-label' | translate | titlecase }}
            <input type="url" class="form-control" [(ngModel)]="event.RelatedWebsite" [required]="showRelatedWebsite" />
          </p>

          <p>
            <label
              ><input type="checkbox" [(ngModel)]="event.ShowMap" />
              {{ 'events.settings.registration-settings.show-map' | translate | titlecase }}</label
            >
          </p>

          <div>
            <label
              ><input type="checkbox" [(ngModel)]="showOverrideMapLink" />
              {{ 'events.settings.registration-settings.show-override-map-link' | translate | titlecase }}</label
            >
          </div>
          <p class="wc-event-setting-cb-sub-item" [hidden]="!showOverrideMapLink">
            {{ 'events.settings.registration-settings.enter-url-label' | translate | titlecase }}
            <input type="url" class="form-control" [(ngModel)]="event.MapLink" [required]="showOverrideMapLink" />
          </p>

          <div>
            <label
              ><input type="checkbox" [(ngModel)]="showWeatherLink" />
              {{ 'events.settings.registration-settings.show-weather-link' | translate | titlecase }}</label
            >
          </div>
          <p class="wc-event-setting-cb-sub-item" [hidden]="!showWeatherLink">
            {{ 'events.settings.registration-settings.enter-url-label' | translate | titlecase }}
            <input type="url" class="form-control" [(ngModel)]="event.WeatherLink" [required]="showWeatherLink" />
          </p>

          <div>
            <label
              ><input type="checkbox" [(ngModel)]="event.ShowAttendeeDetail" />
              {{ 'events.settings.registration-settings.show-attendee-detail' | translate | titlecase }}</label
            >
          </div>
          <div class="wc-event-setting-cb-sub-item" [hidden]="!event.ShowAttendeeDetail">
            {{ 'events.settings.registration-settings.after' | translate }}
            <input type="number" width="9" [(ngModel)]="event.AttendeeDetailThreshold" />
            {{ 'events.settings.registration-settings.attendees-have-registered' | translate }}
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-sm-3 col-md-2 control-label">{{ 'events.settings.registration-settings.sharing' | translate | titlecase }}</label>
      <div class="col-sm-9 col-md-10">
        <div class="form-control-static">
          <label
            ><input type="checkbox" [(ngModel)]="event.ShareEnabled" />
            {{ 'events.settings.registration-settings.enable-sharing' | translate | titlecase }}</label
          >
          <h4>
            {{ 'events.settings.registration-settings.instructions' | translate | titlecase }}
          </h4>
          <div>
            {{ 'events.settings.registration-settings.instruction-description' | translate }}
          </div>
          <div>
            <textarea
              class="form-control"
              rows="5"
              type="text"
              [(ngModel)]="event.ShareInstructions"
              placeholder="{{ 'events.settings.registration-settings.instruction-placeholder' | translate }}"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-back-to-top></app-back-to-top>
</div>
